var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"menu"}},[_c('form-laporan',{attrs:{"is-edit":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }